import math from './oma_math';

const investointi = [
  { min: 0, max: 10, hinta: 16800 },
  { min: 10, max: 20, hinta: 21000 },
  { min: 20, max: 35, hinta: 31500 },
  { min: 35, max: 75, hinta: 59500 },
  { min: 75, max: 100, hinta: 80500 },
  { min: 100, max: 105, hinta: 84000 },
  { min: 105, max: 140, hinta: 113400 },
  { min: 140, max: 200, hinta: 150500 },
];

export const parametrit = {
  cop: 1.8,
  co2_per_mwh: 84,
  mitoitus_suhde: 0.5,
}

const kaavat = `
kaytettava_korko = hae_kaytettava_korko(rakennustyyppi)

energiakulutus_vuodessa = laske_tarvittava_energia_cop(energia_tarve, cop)

energian_hinta_mwh = (sahkon_hinta / cop) * mitoitus_suhde + sahkon_hinta * (1 - mitoitus_suhde)

muuttuvat_kustannukset_vuodessa = energiakulutus_vuodessa * energian_hinta_mwh

kayttoonottokustannukset = investointi

korot = laske_korot(kayttoonottokustannukset, kaytettava_korko, laina_aika)
paaomakustannukset = korot + kayttoonottokustannukset
paaomakustannukset_vuodessa = paaomakustannukset / kayttoika

kiinteat_kustannukset_vuodessa = investointi * kaytettava_korko / 100

kayttokustannukset_vuodessa = kiinteat_kustannukset_vuodessa + muuttuvat_kustannukset_vuodessa
kayttokustannukset_mwh = kayttokustannukset_vuodessa / energiakulutus_vuodessa

energia_kokonaiskustannukset_vuodessa = kayttokustannukset_vuodessa + paaomakustannukset_vuodessa
energia_kokonaiskustannukset_mwh = energia_kokonaiskustannukset_vuodessa / energia_tarve

kustannukset_kayttoialle = energia_kokonaiskustannukset_vuodessa * kayttoika

co2_vuodessa = energiakulutus_vuodessa * co2_per_mwh
`;

export default {
  investointi(teho) {
    const kategoria = investointi.find(k => teho > k.min && teho <= k.max);

    if (kategoria == null) {
      return null;
    }

    return kategoria.hinta;
  },
  energiaNykykulutuksesta(nykykulutus) {
    const scope = { nykykulutus, ...parametrit };
    math().evaluate('energia = laske_energiatarve_nykykulutuksesta_cop(nykykulutus / 1000, cop)', scope);
    return scope.energia;
  },
  laske(sijainti, rakennustyyppi, tehotarve, energiatarve) {
    const investointi = this.investointi(tehotarve);

    if (investointi == null) {
      return {
        mahdollinen: false,
      }
    }

    const scope = { rakennustyyppi, teho: tehotarve, investointi, energia_tarve: energiatarve, ...parametrit };
    math().evaluate(kaavat, scope);

    return scope;
  },
}
